var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 43,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.556 43h48.888L25 .778.556 43zm26.666-6.667h-4.444V31.89h4.444v4.444zm0-8.889h-4.444v-8.888h4.444v8.888z",
    fill: "#FDB900",
    fillRule: "evenodd"
  })));
}
export default SvgWarningIcon;